import _ from 'lodash';
import React, { useState } from 'react';
import { ButtonWrapper } from '../../../../../global/components/layout/button-wrapper';
import { TcsmModal } from '../../../../../global/components/tcsm-modal';
import { QuickActionItem } from '../../../../../global/models/quick-actions-model';
import { MapPortalProps } from '../../../models/arc-epi-props';
import { QuickActionItemDisplay } from './quick-action-item-display';

interface Props {
    open: boolean;
    portalProps: MapPortalProps;
    setSearchModalOpen: (value: React.SetStateAction<boolean>) => void;
    allQuickActions: QuickActionItem[];
    debounceImplementation?: (func: any, wait?: number) => any;
}
export function QuickActionSearch(props: Props) {
    const { open, portalProps, setSearchModalOpen, allQuickActions, debounceImplementation } = props;


    const [searchTerm, setSearchTerm] = useState('');
    const [hasSearched, setHasSearched] = useState(false);
    const [filteredActions, setFilteredActions] = useState([]);

    const noResults = hasSearched && filteredActions?.length === 0;

    const onClear = (ignoreSearchTerm?: boolean) => {
        if (!ignoreSearchTerm) {
            setSearchTerm('');
        }

        setFilteredActions([]);
        setHasSearched(false);
    };

    const handleSearchTerm = (value: string) => {
        if (value?.length >= 3) {
            setHasSearched(true);
            setFilteredActions(allQuickActions.filter(q => q.actionName?.toLowerCase().trim().includes(value?.toLowerCase().trim())));
        } else if (hasSearched) {
            onClear(true);
        }
    };

    const debounceSearch = _.debounce(handleSearchTerm, 500);

    const onChange = (e) => {
        const { value } = e.target;

        setSearchTerm(value);
        if (debounceImplementation) {
            debounceImplementation(handleSearchTerm, 500);
        } else {
            debounceSearch(value);
        }
    };

    const onReset = () => {
        setFilteredActions([]);
        setSearchTerm('');
        setHasSearched(false);
    };

    const onClose = () => {
        onReset();
        setSearchModalOpen(false);
    };

    const renderIcon = () => {
        if (searchTerm?.length < 1) {
            return (

                <svg className=' quick-action-search-icon' aria-hidden='true' focusable='false'>
                    <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#search-icon' />
                </svg>
            );
        }

        return (
            <button data-testid='quick-action-button-clear' className='quick-action-search-button quick-action-search-clear' type='button' onClick={() => onClear()}>
                <svg className='icon' aria-hidden='true' focusable='false'>
                    <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#input-clear-icon' />
                </svg>
            </button>
        );
    };

    return (
        <TcsmModal open={open} handleClose={onClose}>
            <div className='quick-action-search'>
                <h2 className='quick-action-search-header'>{portalProps?.searchQuickActionsModalHeader}</h2>
                <div className='quick-action-search-bar'>
                    <input
                        data-testid='quick-action-search-input'
                        className='quick-action-search-input'
                        value={searchTerm}
                        type='text'
                        placeholder={portalProps?.searchQuickActionsPlaceholderText}
                        onChange={onChange} />
                    {renderIcon()}
                </div>
                <div className='quick-action-search-results'>
                    {filteredActions?.length > 0 && <h3 className='quick-action-search-results-header'>{portalProps?.searchQuickActionsResultsHeader}</h3>}
                    {
                        filteredActions?.map(f => <QuickActionItemDisplay key={f.id} item={f} reordering={false} />)
                    }
                    {
                        noResults &&
                        <p>{portalProps?.searchQuickActionsNoResultsMessage || 'No results'}</p>
                    }
                </div>
                {
                    filteredActions?.length > 0 &&
                    <ButtonWrapper flexEnd>
                        <button
                            type='button'
                            className='btn-tertiary'
                            onClick={onClose}>
                            {portalProps?.cancelText || 'Cancel'}
                        </button>
                    </ButtonWrapper>
                }
            </div>
        </TcsmModal>
    );
}

QuickActionSearch.defaultProps = {
    debounceImplementation: null,
};

export default QuickActionSearch;